module.exports = __webpack_public_path__ + "img/blue-inform-bg.1bedcf3.png";